<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 19:29:09
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 14:45:18
-->
<template>
	<span>
		<el-dialog title="提示" width="426px" show-close :visible.sync="visible" :close-on-click-modal="false">
			<p>{{ content }}</p>
			<div slot="footer" class="dialog-footer">
				<el-tooltip placement="top">
					<img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160" />
					<a href="javascript:;" class="fz-14 mr-20 link yx-color-text-regular">遇到困难？联系客服</a>
				</el-tooltip>
				<el-button type="primary" @click="confirm">去授权</el-button>
			</div>
		</el-dialog>
		<authDialog @success="onSuccess" ref="dialog"></authDialog>
	</span>
</template>
<script>
import mixin from '@/mixins';
import AuthDialog from './authDialog';
const contentConf = {
	goods: {
		content: '授权完成后，即可一键同步所有商品',
	},
	activity: {
		content: '授权后即可同步所有团长活动',
	},
};
export default {
	name: 'auth-alert',
	mixins: [mixin],
	props: {
		type: {
			type: String,
			default: 'goods',
			validator: val => !['goods', 'activity'].includes[val],
		},
	},
	data() {
		return {
			visible: false,
			link: '',
			call_id: 0,
		};
	},
	computed: {
		content() {
			return contentConf[this.type].content;
		},
	},
	methods: {
		init(link, platformId, call_id) {
			this.link = link;
			this.call_id = call_id;
			this.platformId = platformId;
			this.visible = true;
		},
		confirm() {
			const { platformId, openBlankWindow, link, call_id } = this;
			openBlankWindow(link);
			this.visible = false;
			this.$refs.dialog.show(link, platformId, call_id);
		},
		onSuccess() {
			this.$emit('success');
		},
	},
	components: {
		AuthDialog,
	},
};
</script>
